/**
 * @fileoverview Utility for redirecting the browser to the base domain.
 *
 * Exports a constant for the base domain and a function to perform the redirect,
 * preserving protocol, port, pathname, search, and hash.
 */

export const BASE_DOMAIN = import.meta.env.VITE_SAFE_DOMAIN ?? 'rex.local'

/**
 * Redirects the browser to the base domain, preserving the current protocol,
 * port, pathname, search, and hash.
 */
export function redirectToBaseDomain() {
  const { protocol, port, pathname, search, hash } = window.location
  const host = `${BASE_DOMAIN}${port ? `:${port}` : ''}`
  window.location.href = `${protocol}//${host}${pathname}${search}${hash}`
}
